import { MomentumModalV4 } from "@circle-react-shared/ModalsV2/MomentumModalV4";

import { t } from "@/i18n-js/instance";
import { ActionButton } from "@/react/components/shared/ModalsV2/MomentumModalV4/ActionButton";
import { ShareNotice } from "@/react/components/shared/ModalsV2/MomentumModalV4/ShareNotice";

interface WorkflowsMomentumModalV4Props {
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  onCreateWorkflow: () => void;
  templateKey: string;
}

export const WorkflowsMomentumModalV4 = ({
  isOpen,
  isLoading,
  templateKey,
  onClose,
  onCreateWorkflow,
}: WorkflowsMomentumModalV4Props) => (
  <MomentumModalV4
    isOpen={isOpen}
    onClose={onClose}
    title={t(`workflows_v2.momentum_modal.${templateKey}.title`)}
    description={t(`workflows_v2.momentum_modal.${templateKey}.description`)}
    isLoading={isLoading}
  >
    <ShareNotice
      title={t(`workflows_v2.momentum_modal.${templateKey}.notice.title`)}
      description={t(
        `workflows_v2.momentum_modal.${templateKey}.notice.description`,
      )}
    >
      <ActionButton
        startIcon="zap"
        onClick={onCreateWorkflow}
        disabled={isLoading}
        data-testid="create-moderation-workflow-button"
      >
        {t(`workflows_v2.momentum_modal.${templateKey}.notice.button`)}
      </ActionButton>
    </ShareNotice>
  </MomentumModalV4>
);
